import React from 'react';
export function ParallaxBreakSection() {
  return <section className="relative w-full h-[350px] md:h-[450px] lg:h-[500px] bg-cover bg-center bg-fixed" style={{
    backgroundImage: 'url(https://assets.modern-commerce.io/Glenlofty%20Project%20Files/DJI_0231.jpg)'
  }} role="img" aria-label="Aerial view of Glenlofty Estate vineyards" data-id="element-130" />;
}